module.exports = __webpack_public_path__ + "static/media/Inventory_Illustration.a92e7c59.png";